import Footer from 'components/nav/Footer'
import Header from 'components/nav/Header'
import { ReactFC } from 'common/types/ReactFC'
import { useWithoutNav } from 'project/isWithoutNav'

export type PageContainerProps = {
  hideFooterCard?: boolean
  transparentHeader?: boolean
  hideFooter?: boolean
  au?: boolean
}
export const PageContainer: ReactFC<PageContainerProps> = ({
  au,
  children,
  hideFooter,
  hideFooterCard,
  transparentHeader,
}) => {
  const hideNav = useWithoutNav()
  return (
    <>
      {!hideNav && <Header au={au} transparentHeader={transparentHeader} />}
      {children}
      {!hideNav && !hideFooter && (
        <Footer au={au} hideFooterCard={hideFooterCard} />
      )}
    </>
  )
}

PageContainer.displayName = 'PageContainer'
export default PageContainer
